document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;

  // ====== Cache common elements ======
  const mobileMenuOpenBtn = document.querySelector('.rs-navigation-hamb__button');
  const mobileMenuCloseBtn = document.querySelector('.rs-navigation-close__button');
  const mobileMenuCloseButtons = document.querySelectorAll('.rs-navigation-close__button, .rs-menu-mobile-close-btn');
  const mobileMenuContainer = document.querySelector('.rs-navigation__mobile');

  const subMenuOpenBtns = document.querySelectorAll('.rs-menu-mobile [data-rs-mobile-submenu-toggle]');
  const subMenuBackBtns = document.querySelectorAll('.rs-menu-mobile-sublist-back-btn, .rs-menu-mobile-sub-sublist-back-btn');

  const overflowMask = document.querySelector('.rs-overflow-mask');

  // ====== Dropdown overlay (replaces rs-overflow-mask for account/location/org dropdowns) ======
  const dropdownOverlay = document.createElement('div');
  dropdownOverlay.className = 'rs-dropdown-overlay';
  document.body.appendChild(dropdownOverlay);

  const showDropdownOverlay = () => dropdownOverlay.classList.add('rs-active');
  const hideDropdownOverlay = () => dropdownOverlay.classList.remove('rs-active');

  // Clicking the overlay closes all dropdowns
  dropdownOverlay.addEventListener('click', () => {
    closeAllDropdowns();
    closeAllMega();
    hideDropdownOverlay();
  });

  // ====== Dropdown configs (click-driven dropdowns) ======
  const DROPDOWNS = [
    {
      btnSelector: '.rs-sign-in__button',
      closeBtnSelector: '.rs-sign-in-dropdown__close-btn',
      containerSelector: '.rs-sign-in',
      contentSelector: '.rs-sign-in__dropdown',
      bodyOpenClass: 'rs-sign-in-dropdown-open',
    },
    {
      btnSelector: '.rs-customer-dropdown__button',
      containerSelector: '.rs-customer-dropdown',
      contentSelector: '.rs-customer-dropdown__content',
      bodyOpenClass: 'rs-customer-open',
    },
    {
      btnSelector: '.rs-location-dropdown__button',
      closeBtnSelector: '.rs-location-close-btn',
      searchInputSelector: '.rs-location-dropdown__search-wrapper .rs-input',
      containerSelector: '.rs-location-dropdown',
      contentSelector: '.rs-location-dropdown__content',
      bodyOpenClass: 'rs-location-open',
    },
    {
      btnSelector: '.rs-organization-dropdown__button',
      closeBtnSelector: '.rs-organization-close-btn',
      searchInputSelector: '.rs-organization-dropdown__search-wrapper .rs-input',
      containerSelector: '.rs-organization-dropdown',
      contentSelector: '.rs-organization-dropdown__content',
      bodyOpenClass: 'rs-organization-open',
    },
    {
      btnSelector: '.rs-order-dropdown__button',
      containerSelector: '.rs-order-dropdown',
      contentSelector: '.rs-order-dropdown__content',
      bodyOpenClass: 'rs-order-open',
    }
  ];

  // ====== Utilities ======
  const anyDropdownOpen = () => DROPDOWNS.some(({ bodyOpenClass }) => body.classList.contains(bodyOpenClass));

  const syncGlobalOpenFlag = () => {
    const anyContainerActive = DROPDOWNS.some(({ containerSelector }) =>
      document.querySelector(`${containerSelector}.rs-active`)
    );
    if (anyDropdownOpen() || anyContainerActive || anyMegaOpen()) body.classList.add('rs-open');
    else body.classList.remove('rs-open');
  };

  const closeDropdownType = ({ containerSelector, bodyOpenClass }) => {
    const openEl = document.querySelector(`${containerSelector}.rs-active`);
    if (openEl) openEl.classList.remove('rs-active');
    // Only remove the body class if the container is no longer active
    if (!document.querySelector(`${containerSelector}.rs-active`)) {
      body.classList.remove(bodyOpenClass);
    }
  };

  const closeAllDropdowns = () => {
    DROPDOWNS.forEach(closeDropdownType);
    syncGlobalOpenFlag();
    hideDropdownOverlay();
  };

  const updateOverflowMask = (anchorEl) => {
    if (!overflowMask || !anchorEl) return;
    requestAnimationFrame(() => {
      const top = anchorEl.getBoundingClientRect().top + window.scrollY;
      overflowMask.style.top = `${top}px`;
      overflowMask.style.display = 'block';
    });
  };

  const hideOverflowMask = () => {
    if (!overflowMask) return;
    // Only hide the mask if no dropdown container is still visually open (has rs-active).
    // This prevents other close handlers (e.g. mega menu mouseleave, focusout) from
    // hiding the mask while an account/location dropdown is still active.
    const anyContainerActive = DROPDOWNS.some(({ containerSelector }) =>
      document.querySelector(`${containerSelector}.rs-active`)
    );
    if (anyContainerActive || anyMegaOpen()) return;
    overflowMask.style.display = 'none';
    // optional: overflowMask.style.top = '';
  };

  const getActiveDropdownInfo = () => {
    for (const cfg of DROPDOWNS) {
      const container = document.querySelector(`${cfg.containerSelector}.rs-active`);
      if (container) {
        const content = container.querySelector(cfg.contentSelector);
        return { cfg, container, content };
      }
    }
    return null;
  };

  const OVERLAY_DROPDOWNS = ['.rs-location-dropdown', '.rs-organization-dropdown', '.rs-customer-dropdown'];

  const toggleDropdownByButton = (button, { containerSelector, contentSelector, bodyOpenClass }) => {
    if (!button) return;
    const container = button.closest(containerSelector);
    if (!container) return;

    const isOpening = !container.classList.contains('rs-active');
    const usesOverlay = OVERLAY_DROPDOWNS.includes(containerSelector);

    // Close other dropdowns + mega menus to keep UI clean
    closeAllDropdowns();
    closeAllMega();
    hideDropdownOverlay();

    // Close the menu if it is open
    if (containerSelector !== '.rs-location-dropdown' && containerSelector !== '.rs-organization-dropdown' && containerSelector !== '.rs-order-dropdown') {
      body.classList.remove('rs-mobile-menu-open');
      mobileMenuCloseBtn?.classList.add('rs-hidden');
      mobileMenuOpenBtn?.classList.remove('rs-hidden');
    }

    if (isOpening) {
      container.classList.add('rs-active');
      body.classList.add(bodyOpenClass);
      syncGlobalOpenFlag();

      if (usesOverlay) {
        showDropdownOverlay();
      } else {
        const content = container.querySelector(contentSelector);
        updateOverflowMask(content);
      }
    } else {
      body.classList.remove(bodyOpenClass);
      syncGlobalOpenFlag();
      hideOverflowMask();
      hideDropdownOverlay();
    }
  };

  // ====== Mobile menu focus trap ======
  // The close button lives outside .rs-navigation__mobile, so we build our own
  // focus cycle that prepends it to the panel's focusable elements.
  const MOBILE_FOCUSABLE =
    'a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled])';

  const isMobileVisible = (el) => {
    if (el.closest('.rs-hidden') || el.closest('[hidden]')) return false;
    const s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    if (el.offsetParent !== null || s.position === 'fixed') return true;
    // Fallback for elements that are visually present but have offsetParent === null
    // (e.g. logo anchor inside a flex container where offsetParent resolution is unreliable).
    // getBoundingClientRect returns all-zeros for display:none ancestors, so this stays correct.
    const rect = el.getBoundingClientRect();
    return rect.width > 0 || rect.height > 0;
  };

  const getMobileFocusables = () => {
    const seen = new Set();
    const items = [];
    const addEl = (el) => {
      if (!seen.has(el)) {
        seen.add(el);
        items.push(el);
      }
    };

    // 1. Header bar: X close, logo, cart, account icon (DOM order).
    //    Scope to the X button's nearest .rs-group-item ancestor so the search
    //    box — which is a sibling of that row, not inside it — is never pulled
    //    in. This works for both logged-in and logged-out users without needing
    //    to detect which auth-conditional elements are present.
    if (mobileMenuCloseBtn) {
      const mobileRow = mobileMenuCloseBtn.closest('.rs-group-item');
      if (mobileRow) {
        Array.from(mobileRow.querySelectorAll(MOBILE_FOCUSABLE))
          .filter((el) => !el.hasAttribute('disabled') && isMobileVisible(el))
          .forEach(addEl);
      }
    }

    // 2. Mobile nav panel: company ([data-clear-search-label]), location,
    //    menu items, sign out (DOM order).
    if (mobileMenuContainer) {
      Array.from(mobileMenuContainer.querySelectorAll(MOBILE_FOCUSABLE))
        .filter((el) => !el.hasAttribute('disabled') && isMobileVisible(el))
        .forEach(addEl);
    }

    return items;
  };

  let mobileTrapKeydown = null;

  const trapMobileMenuFocus = () => {
    removeMobileTrap();
    mobileTrapKeydown = (e) => {
      if (e.key !== 'Tab') return;
      const items = getMobileFocusables();
      if (!items.length) return;
      e.preventDefault();
      const idx = items.indexOf(document.activeElement);
      if (e.shiftKey) {
        items[idx <= 0 ? items.length - 1 : idx - 1]?.focus();
      } else {
        items[idx >= items.length - 1 ? 0 : idx + 1]?.focus();
      }
    };
    document.addEventListener('keydown', mobileTrapKeydown, true);
    mobileMenuCloseBtn?.focus({ preventScroll: true });
  };

  const removeMobileTrap = () => {
    if (mobileTrapKeydown) {
      document.removeEventListener('keydown', mobileTrapKeydown, true);
      mobileTrapKeydown = null;
    }
    window.RSFocus?.removeTrapFocus?.();
  };

  const closeMobileSubmenu = (sublistWrapper) => {
    if (!sublistWrapper) return;
    sublistWrapper.classList.add('rs-hidden');

    const opener = sublistWrapper.id
      ? document.querySelector(`.rs-menu-mobile [data-rs-mobile-submenu-toggle][aria-controls="${sublistWrapper.id}"]`)
      : null;
    opener?.setAttribute('aria-expanded', 'false');
  };

  const closeAllMobileSubmenus = () => {
    document
      .querySelectorAll('.rs-menu-mobile-sublist-wrapper, .rs-menu-mobile-sub-sublist-wrapper')
      .forEach(closeMobileSubmenu);
  };

  // ====== Mobile menu ======
  mobileMenuOpenBtn?.addEventListener('click', function () {
    body.classList.add('rs-mobile-menu-open');
    mobileMenuCloseBtn?.classList.remove('rs-hidden');
    mobileMenuOpenBtn?.classList.add('rs-hidden');
    requestAnimationFrame(() => {
      trapMobileMenuFocus();
    });
  });

  mobileMenuCloseButtons.forEach((btn) => {
    btn.addEventListener('click', function () {
      body.classList.remove('rs-mobile-menu-open');
      removeMobileTrap();
      closeAllMobileSubmenus();
      const menu = document.querySelector('.rs-navigation__mobile');
      if (menu) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            mobileMenuOpenBtn.focus({ preventScroll: true });
          });
        });
      } else {
        mobileMenuOpenBtn.focus({ preventScroll: true });
      }
    });
  });

  // Keep the open/close button visibility in sync
  document.addEventListener('click', () => {
    if (body.classList.contains('rs-mobile-menu-open')) {
      mobileMenuCloseBtn?.classList.remove('rs-hidden');
      mobileMenuOpenBtn?.classList.add('rs-hidden');
    } else {
      mobileMenuCloseBtn?.classList.add('rs-hidden');
      mobileMenuOpenBtn?.classList.remove('rs-hidden');
      removeMobileTrap();
    }
  });

  // ====== Mobile submenu toggle ======
  subMenuOpenBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const controlledId = btn.getAttribute('aria-controls');
      const sublistWrapper = controlledId ? document.getElementById(controlledId) : null;
      sublistWrapper?.classList.remove('rs-hidden');
      btn.setAttribute('aria-expanded', 'true');
    });
  });

  subMenuBackBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const sublistWrapper = btn.closest('.rs-menu-mobile-sublist-wrapper, .rs-menu-mobile-sub-sublist-wrapper');
      closeMobileSubmenu(sublistWrapper);
    });
  });

  // ====== Click-driven dropdowns: customer/location/organization ======

  DROPDOWNS.forEach((cfg) => {
    const isHoverDropDowns = cfg.btnSelector === '.rs-organization-dropdown__button' || cfg.btnSelector === '.rs-location-dropdown__button' || cfg.btnSelector === '.rs-customer-dropdown__button' || cfg.btnSelector === '.rs-order-dropdown__button';

    // Bind click and keyboard toggle for all dropdowns (desktop + mobile)
    document.querySelectorAll(cfg.btnSelector).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation(); // prevent outside-click from immediately closing
        toggleDropdownByButton(btn, cfg);
      });

      btn.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggleDropdownByButton(btn, cfg);
        }
      });
    });

    // Close dropdown when focus leaves the entire container.
    // Track the last mousedown target so we can check if a click inside the
    // dropdown caused the focusout (clicking non-focusable elements sets
    // activeElement to body, so we can't rely on activeElement alone).
    if (isHoverDropDowns) {
      const container = document.querySelector(cfg.containerSelector);
      if (container) {
        let lastMousedownInside = false;
        container.addEventListener('mousedown', () => {
          lastMousedownInside = true;
          setTimeout(() => { lastMousedownInside = false; }, 300);
        });
        container.addEventListener('focusout', (e) => {
          const relatedTarget = e.relatedTarget;
          if (relatedTarget && container.contains(relatedTarget)) return;
          setTimeout(() => {
            if (lastMousedownInside) return;
            if (container.contains(document.activeElement)) return;
            closeDropdownType(cfg);
            hideOverflowMask();
            hideDropdownOverlay();
            syncGlobalOpenFlag();
          }, 200);
        });
      }
    }

    if (cfg.closeBtnSelector) {
      document.querySelectorAll(cfg.closeBtnSelector).forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeDropdownType(cfg);
          hideOverflowMask();
          syncGlobalOpenFlag();
        });
      });
    }

    // ====== Search (2+ chars: match by ID, address, ZIP) ======
    if (cfg.searchInputSelector) {
      document.querySelectorAll(cfg.searchInputSelector).forEach((input) => {
        const container = input.closest(cfg.containerSelector) || document.querySelector(cfg.containerSelector);
        const content = container?.querySelector(cfg.contentSelector) || input.closest(cfg.contentSelector);
        if (!container || !content) return;
        const isAdminApiSearch =
          (cfg.containerSelector === '.rs-organization-dropdown' || cfg.containerSelector === '.rs-location-dropdown') &&
          ['admin', 'sales_admin', 'customer_service', 'sales_rep'].includes(
            (document.body.getAttribute('data-customer-user-type') || '').trim().toLowerCase()
          );
        const MIN_CHARS = 2;
        const HIDDEN = 'rs-hidden';

        // Try sensible defaults per dropdown type; fallbacks included
        const isLocation = container.matches('.rs-location-dropdown');
        const itemSelector = isLocation ? '.rs-location-picker' : '.rs-organization-picker, .rs-location-picker';
        const idSelector = isLocation ? '.rs-location-picker__id' : '.rs-organization-picker__id, .rs-location-picker__id';
        const addrSelector = isLocation
          ? '.rs-location-picker__address-line'
          : '.rs-organization-picker__address, .rs-location-picker__address';

        const normalize = (s) => (s || '').toString().trim().toLowerCase();
        const digitsOnly = (s) => (s || '').replace(/\D+/g, '');
        const extractZip = (s) => {
          const m = (s || '').match(/\b\d{5}(?:-\d{4})?\b/i);
          return m ? m[0] : '';
        };

        // Ensure a lightweight "No results" row exists
        let noResults = content.querySelector('.rs-no-results');
        if (!noResults) {
          noResults = document.createElement('div');
          noResults.className = `rs-no-results text-primary text-medium weight-600 ${HIDDEN}`;
          noResults.style.paddingBottom = '24px';
          noResults.textContent = 'No results';
          content.appendChild(noResults);
        }

        const applyFilter = (qRaw) => {
          if (isAdminApiSearch) return;
          const q = normalize(qRaw);
          const showAll = q.length < MIN_CHARS;

          // Rebuild index each time since location options are populated dynamically
          const items = Array.from(content.querySelectorAll(itemSelector));

          // Precompute digit-only query for ID match
          const qDigits = q.replace(/\D+/g, '');

          let visible = 0;
          items.forEach((el) => {
            const idText = el.querySelector(idSelector)?.textContent || '';
            const addr = el.querySelector(addrSelector)?.textContent || '';
            const idTextNorm = normalize(idText);
            const idDigits = digitsOnly(idText);
            const addrNorm = normalize(addr);
            const zip = extractZip(addr).toLowerCase();

            const match = showAll || idTextNorm.includes(q) || addrNorm.includes(q) || (qDigits && idDigits.includes(qDigits)) || (zip && zip.includes(q));
            if (match) {
              el.classList.remove(HIDDEN);
              visible++;
            } else {
              el.classList.add(HIDDEN);
            }
          });

          // No results toggle
          if (!showAll && visible === 0) {
            noResults.classList.remove(HIDDEN);
          } else {
            noResults.classList.add(HIDDEN);
          }
        };

        let syncDropdownSearchClearUi = () => {};
        const inputWrapper = input.closest('.rs-input__wrapper');
        if (inputWrapper) {
          if (input.dataset.rsDropdownSearchClearWired !== '1') {
            input.dataset.rsDropdownSearchClearWired = '1';
            const clearLabel = container.dataset.clearSearchLabel || 'Clear search';
            const clearBtn = document.createElement('button');
            clearBtn.type = 'button';
            clearBtn.className = 'rs-button-unstyled rs-dropdown-search-clear';
            clearBtn.setAttribute('aria-label', clearLabel);
            clearBtn.innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="rs-icon rs-icon-close" aria-hidden="true" focusable="false">' +
              '<path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '<path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>';
            clearBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              input.value = '';
              applyFilter('');
              syncDropdownSearchClearUi();
              input.focus();
            });
            inputWrapper.appendChild(clearBtn);
            clearBtn.classList.add('rs-hidden');
          }
          const clearBtnEl = inputWrapper.querySelector('.rs-dropdown-search-clear');
          const searchIconEl = inputWrapper.querySelector('.rs-icon__input-right');
          syncDropdownSearchClearUi = () => {
            const hasVal = (input.value || '').trim().length > 0;
            if (clearBtnEl) clearBtnEl.classList.toggle('rs-hidden', !hasVal);
            if (searchIconEl) searchIconEl.classList.toggle('rs-hidden', hasVal);
          };
        }

        // Debounce input
        let t;
        input.addEventListener('input', (e) => {
          syncDropdownSearchClearUi();
          clearTimeout(t);
          const val = e.target.value || '';
          t = setTimeout(() => applyFilter(val), 150);
        });

        // Initial: show all
        applyFilter('');
        syncDropdownSearchClearUi();
      });
    }
  });

  // ====== Mega menu (hover-driven) ======
  // Markup assumptions:
  // - Each mega item: <li class="rs-menu-item-with-sublist"> ... <ul class="rs-menu-sublist"> ... </ul> </li>
  const MEGA_ITEM_SELECTOR = '.rs-menu-item-with-sublist';
  const MEGA_SUB_SELECTOR = '.rs-menu-sublist';

  const openMega = (item) => {
    const sub = item.querySelector(MEGA_SUB_SELECTOR);
    if (!sub) return;

    // Close other UIs
    closeAllDropdowns();
    closeAllMega({ except: item });

    // Show sublist (JS-only; no CSS required)
    item.classList.add('rs-active-mega');

    // Mark body state and show mask aligned to the sublist
    body.classList.add('rs-mega-open');
    syncGlobalOpenFlag();
    updateOverflowMask(sub);
  };

  const closeMega = (item) => {
    item?.classList.remove('rs-active-mega');
  };

  const anyMegaOpen = () => !!document.querySelector('.rs-menu-item-with-sublist.rs-active-mega');

  const closeAllMega = ({ except } = {}) => {
    document.querySelectorAll(MEGA_ITEM_SELECTOR).forEach((it) => {
      if (except && it === except) return;
      closeMega(it);
    });
    if (!anyMegaOpen()) {
      body.classList.remove('rs-mega-open');
      syncGlobalOpenFlag();
      hideOverflowMask();
    }
  };

  // Hover/focus behavior
  let megaHideTimer;

  const scheduleMegaHide = () => {
    if (megaHideTimer) clearTimeout(megaHideTimer);
    megaHideTimer = setTimeout(() => {
      megaHideTimer = null;
      closeAllMega();
    }, 120);
  };

  const cancelMegaHide = () => {
    if (megaHideTimer) {
      clearTimeout(megaHideTimer);
      megaHideTimer = null;
    }
  };

  const bindMegaItem = (item) => {
    if (item.dataset.rsMegaBound === '1') return;

    const sub = item.querySelector(MEGA_SUB_SELECTOR);
    if (!sub) return;
    item.dataset.rsMegaBound = '1';

    const link = item.querySelector('.rs-menu-link');
    link?.addEventListener('click', (e) => {
      if (link.getAttribute('href') === '#') {
        e.preventDefault();
      }
    });

    const isMenuHovered = () => item.matches(':hover');

    // Mouse enters the li: open
    item.addEventListener('mouseenter', () => {
      cancelMegaHide();
      openMega(item);
    });

    // Leave the entire li (link + submenu): schedule hide
    item.addEventListener('mouseleave', scheduleMegaHide);

    // Keyboard accessibility: close menu when focus leaves the menu area
    const handleFocusOut = (e) => {
      // Check if focus is moving to another element within the menu (item or submenu)
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && (item.contains(relatedTarget) || sub.contains(relatedTarget))) {
        // Focus is moving within the menu, don't close
        return;
      }
      if (isMenuHovered()) return;
      // Focus is leaving the menu area, close it
      scheduleMegaHide();
    };

    item.addEventListener('focusout', handleFocusOut);
    sub.addEventListener('focusout', handleFocusOut);

    // Keyboard accessibility: space or enter to toggle
    item.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        const isOpen = item.classList.contains('rs-active-mega');
        if (isOpen) {
          closeMega(item);
          if (!anyMegaOpen()) {
            body.classList.remove('rs-mega-open');
            syncGlobalOpenFlag();
            hideOverflowMask();
          }
        } else {
          cancelMegaHide();
          openMega(item);
        }
      }
    });
  };

  const bindMegaItems = () => {
    document.querySelectorAll(MEGA_ITEM_SELECTOR).forEach(bindMegaItem);
  };

  bindMegaItems();
  document.addEventListener('rs:navigation:refresh', bindMegaItems);

  // Keep mask aligned if page scrolls/resizes while a thing is open
  const refreshMask = () => {
    if (anyMegaOpen()) {
      const activeMega = document.querySelector('.rs-menu-item-with-sublist.rs-active-mega > .rs-menu-sublist');
      if (activeMega) updateOverflowMask(activeMega);
    } else {
      const activeDropdown = getActiveDropdownInfo();
      if (activeDropdown?.content) updateOverflowMask(activeDropdown.content);
    }
  };
  window.addEventListener('scroll', refreshMask, { passive: true });
  window.addEventListener('resize', refreshMask);

  // ====== Global outside-click closes everything ======
  document.addEventListener('click', function (e) {
    const clickedInsideDropdown = DROPDOWNS.some(({ containerSelector }) => e.target.closest(containerSelector));
    const clickedInsideMega = !!e.target.closest(MEGA_ITEM_SELECTOR);
    const clickedOnMask = e.target.classList.contains('rs-overflow-mask');

    if (clickedInsideDropdown || clickedInsideMega) {
      return;
    }

    // Clicking the overlay mask should close dropdowns
    if (clickedOnMask) {
      closeAllDropdowns();
      closeAllMega();
      return;
    }

    closeAllDropdowns();
    closeAllMega();
  });

  // ====== Escape closes everything ======
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllDropdowns();
      closeAllMega();
    }
  });

});
